module.exports = __webpack_public_path__ + "media/images/streamline_voice-mail-8667c5e2.png";